import { createFileRoute } from "@tanstack/react-router";
import { MessageCircle, Mail, MapPin, Clock, Calendar } from "lucide-react";
import { Page, SectionEyebrow, CTAButton } from "@/components/SiteLayout";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact — Hi Coach" },
      { name: "description", content: "Bereik Hi Coach via WhatsApp of e-mail. Gymzaal de Bongerd in Rhoon, elke zondagochtend." },
      { property: "og:title", content: "Contact — Hi Coach" },
      { property: "og:description", content: "Kom in contact met Hi Coach." },
      { property: "og:url", content: "/contact" },
    ],
    links: [{ rel: "canonical", href: "/contact" }],
  }),
  component: Contact,
});

function Contact() {
  return (
    <Page>
      <section className="pt-24 pb-10 bg-white">
        <div className="mx-auto max-w-4xl px-6">
          <SectionEyebrow color="var(--rb-blue)">Contact</SectionEyebrow>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
            Kom in <span style={{ color: "var(--rb-blue)" }}>contact</span>
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Heb je een vraag, wil je meer weten of ben je er klaar voor? We zijn makkelijk te bereiken.
          </p>
        </div>
      </section>

      <section className="py-10">
        <div className="mx-auto max-w-5xl px-6 grid md:grid-cols-2 gap-6">
          <div className="rounded-3xl p-8 shadow-md text-white" style={{ background: "var(--rb-green)" }}>
            <MessageCircle size={36} />
            <h3 className="mt-4 text-2xl font-extrabold">WhatsApp</h3>
            <p className="mt-2">De snelste manier. Stuur een berichtje en we reageren binnen een dag.</p>
            <a href="https://wa.me/31626716754" className="btn-cta-inverse mt-6">App ons direct</a>
          </div>
          <div className="rounded-3xl p-8 shadow-md text-white" style={{ background: "var(--rb-blue)" }}>
            <Mail size={36} />
            <h3 className="mt-4 text-2xl font-extrabold">E-mail</h3>
            <p className="mt-2">Liever mailen? Dat kan ook.</p>
            <a href="mailto:info@hicoachclub.nl" className="btn-cta-inverse mt-6" style={{ color: "var(--rb-blue)" }}>Stuur een mail</a>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto max-w-5xl px-6">
          <h2 className="text-3xl md:text-4xl font-extrabold">Praktische info.</h2>
          <div className="mt-8 grid md:grid-cols-3 gap-5">
            {[
              { ic: <MapPin />, c: "#FF0000", t: "Locatie", d: "Gymzaal De Beurs 41, 3162 WB Rhoon." },
              { ic: <Clock />, c: "#FFD700", t: "Tijdstip", d: "Zondagochtend tussen 09.00 en 13.00 uur. Een les duurt een vol uur (inclusief fruit- en uitstroommoment)." },
              { ic: <Calendar />, c: "#1E90FF", t: "Seizoen", d: "Begin september 2026 tot en met juni 2027. Geen les in schoolvakanties en op feestdagen." },
            ].map((b) => (
              <div key={b.t} className="rounded-2xl bg-white border border-border p-6 shadow-sm border-t-8" style={{ borderTopColor: b.c }}>
                <div style={{ color: b.c }}>{b.ic}</div>
                <h3 className="mt-3 text-xl font-extrabold">{b.t}</h3>
                <p className="mt-2 text-muted-foreground">{b.d}</p>
              </div>
            ))}
          </div>
          <a
            href="https://maps.app.goo.gl/hK9gJ7s5TfnJFKaj7?g_st=aw"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 block rounded-3xl overflow-hidden border border-border shadow-sm relative"
          >
            <iframe
              title="Hi Coach locatie — De Beurs 41 Rhoon"
              src="https://www.google.com/maps?q=De+Beurs+41,+3162+WB+Rhoon&output=embed"
              className="w-full h-[360px] border-0 pointer-events-none"
              loading="lazy"
            />
          </a>
        </div>
      </section>

      <section className="py-16 bg-white text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold">Nog niet ingeschreven?</h2>
        <div className="mt-6"><CTAButton /></div>
      </section>
    </Page>
  );
}
